module.exports = "<app-page-card-slider class=\"moly-wrapper slider-page-wrapper\" [section]=\"'moly'\"></app-page-card-slider>\n<app-footer></app-footer>\n"